import React, { memo } from "react";

import { TextField } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from "@material-ui/lab/Autocomplete";

import "./.Basics.css";

const SelectErp = ({
  optionsList = [],
  descriptionField = "descricao",
  getOptionLabel,
  size = "small",
  value,
  setValue,
  required = false,
  error = false,
  helperText,
  placeholder,
  getOptionSelected = (option, value) =>
    option && value ? option.id === value.id : "",
  onChange = (value) => {
    setValue(value);
  },
  onChangeText = () => {},
  loading = false,
  className = "filter-input",
  variant = "standard",
  multiple = false, // caso multiple = true -> value precisa ser um array
  inputRef,
  disabledSearchByText = false,
  noOptionsText = "N/A",
  ...props
}) => {
  // É possível padronizar, colocando um limite de itens mostrados, a maneira de buscar, etc...
  // const filterOptions = createFilterOptions({
  // limit: 50,
  // matchFrom: "start",
  // stringify: (option) => option.title,
  // });
  return (
    <Autocomplete
      filterOptions={disabledSearchByText ? (options) => options : undefined}
      multiple={multiple}
      key={"filter_autocomplete_" + props.label}
      options={Array.isArray(optionsList) ? optionsList : []}
      value={value}
      size={size}
      noOptionsText={noOptionsText}
      loading={loading}
      loadingText="Carregando..."
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      autoHighlight
      getOptionSelected={getOptionSelected}
      getOptionLabel={
        getOptionLabel
          ? getOptionLabel
          : (option) => {
              return option && descriptionField && option[descriptionField]
                ? isNaN(option[descriptionField])
                  ? option[descriptionField]
                  : option[descriptionField].toString()
                : "";
            }
      }
      style={{ width: "100%" }}
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={inputRef}
          helperText={helperText || ""}
          required={required}
          error={!!error}
          label={props.label}
          className={className}
          variant={variant}
          onChange={onChangeText}
          InputLabelProps={{ ...props.InputLabelProps }}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default memo(SelectErp);
